import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from 'app/shared/components/button/button.module';
import { CheckBoxModule } from 'app/shared/components/check-box/check-box.module';
import { InputBoxModule } from 'app/shared/components/input-box/input-box.module';
import { ListModule } from 'app/shared/components/list/list.module';
import { ModalModule } from 'app/shared/components/modal/modal.module';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { EntityFilterFormComponent } from './entity-filter-form.component';

@NgModule({
  imports: [
    CommonModule,
    ListModule,
    CheckBoxModule,
    InputBoxModule,
    ButtonModule,
    ModalModule,
    PipesModule,
  ],
  declarations: [EntityFilterFormComponent],
  exports: [EntityFilterFormComponent],
})
export class EntityFilterFormModule {}
